export const getCSSVariable = (varName: string): string => {
  return `var(${varName})`;
};

export const cssVars = {
  bgColor: getCSSVariable('--bg-color'),
  bgSecondary: getCSSVariable('--bg-secondary'),
  bgTertiary: getCSSVariable('--bg-tertiary'),
  textPrimary: getCSSVariable('--text-primary'),
  textSecondary: getCSSVariable('--text-secondary'),
  textTertiary: getCSSVariable('--text-tertiary'),
  borderColor: getCSSVariable('--border-color'),
  borderLight: getCSSVariable('--border-light'),
  primary: getCSSVariable('--primary'),
  primaryHover: getCSSVariable('--primary-hover'),
  selected: getCSSVariable('--selected'),
  selectedBorder: getCSSVariable('--selected-border'),
  hover: getCSSVariable('--hover'),
  error: getCSSVariable('--error'),
  white: getCSSVariable('--white'),
  sidebarWidth: getCSSVariable('--sidebar-width'),
};

export const createStyledComponent = <T extends keyof JSX.IntrinsicElements>(
  tag: T,
  styles: string
) => {
  return tag;
};
